module.exports = __webpack_public_path__ + "static/media/multiple-choice-image-dest.bb1f8d14.svg";